//pages/im/components/message-emitter/robot-message-emitter/robot-message-emitter.js
import { IMEventBus } from "lib/mp-stjk-im-service";

const IMTypes = {
    CHAT:1,
    CARD:2,
    CONTROL:3,
    DISPLAY_CONTROL:4,
    ROBOT:10000
};

const IMSubTypes = {
    TEXT:1,
    IMAGE:2,
    ROBOT_IN:10000,
    ROBOT_OUT:10001
};

Component({
    /**
     * 组件的属性列表
     */
    properties: {
        robotMsg: {
            type: Object,
            value: {},
            observer: function(robotMsg) {
                // let feature = msg.feature || {};
                let content = robotMsg?._content || robotMsg?.currentNode || {};
                let emitterProps = {};
                // if (typeof msg.feature == "string") {
                //     feature = JSON.parse(msg.feature || "{}");
                // }
                if (typeof content == "string") {
                    content = JSON.parse(content || "{}");
                }
                
                // 拍照节点
                // if (robotMsg.protocolType === 20) {
                //     emitterProps = {
                //         robotMsg
                //     };
                //     this.setData({
                //         emitterProps
                //     });
                // } else {
                    const robotAnswer = content?.runningVertex?.aaaAttrDTO;
                    emitterProps = {
                        robotMsg:content,
                        robotAnswer
                    };
                    // console.log('robotAnswer---->', robotAnswer);
                    this.setData({
                        robotAnswer,
                        emitterProps
                    });
                // }
            }
        }
    },
    /**
     * 组件的初始数据
     */
    data: {
        robotAnswer: {},
        emitterProps: {}
    },

    /**
     * 组件的方法列表
     */
    methods: {
        
        sendRobotMsg: function(e) {
            if (!this.lastClick) {
                this.lastClick = new Date().getTime();
            } else if (new Date().getTime() - this.lastClick < 1000) {
                return;
            } else {
                this.lastClick = new Date().getTime();
            }
            const {
                optionArr,
                robotMsg,
                userAnswerMode = 1, // 默认屏选
                extraContent = {},
                extData = ""
            } = e.detail;

            const { runningVertex, instanceId, applicationId, consultId } = robotMsg || {};
            const { uniqueId: vertexUniqueId } = runningVertex || {};
            const tId = new Date().valueOf();
            optionArr.answer = Object.assign(
                { instanceId, vertexUniqueId, applicationId, consultId },
                optionArr?.answer,
            );
            //feature不需要？
            const data = {
                id: tId,
                sid: tId,
                gmtCreate: tId,
                content: JSON.stringify(optionArr),
                type: IMTypes.ROBOT,
                subType: IMSubTypes.ROBOT_OUT,
            };
            console.log("sendrobotmsg optionArr===>", optionArr);
            console.log("sendrobotmsg robotMsg===>", robotMsg);
            console.log("sendrobotmsg data===>", data);
            // const data = {
            //     flag: 1,
            //     cid,
            //     id: cid,
            //     feature: JSON.stringify({
            //         scene: 0
            //     }), 
            //     created: new Date().valueOf(),
            //     content: JSON.stringify(robotMsgToSend),
            //     subType: robotMsg.isWormHole ? 73001 : robotMsg.isAiMsg ? 72003 : 71001,
            //     type: 8
            // };
            IMEventBus.trigger("SEND_MESSGE", data);
        }
    }
});
